import React from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';

import './ContentLabel.scss';

export default function ContentLabel({ fieldValue }) {
  const label = fieldValue.get('contentLabel');

  if (label) {
    return <div className="cp-bib-content-label">{label}</div>;
  }

  return null;
}

ContentLabel.propTypes = {
  fieldValue: ImmutablePropTypes.map
};
